import SchedulingTypeRepository from '@/shared/http/repositories/configuration/schedulingtype'
import { mutationTypes as mutation } from './mutations'
import store from '@/store/'

const MODULE_NAME = 'schedulingtype/schedulingtypes'
const GET_ALL = 'getAllSchedulingTypes'

export const actionTypes = {
  GET_ALL
}

export const actions = {
  async [GET_ALL] ({ commit }, forceReload) {
    if (store.getters[MODULE_NAME].length === 0 || forceReload) {
      const res = await SchedulingTypeRepository.GetAll()
      commit(mutation.SET_SCHEDULINGTYPES, res.data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/schedulingtype/actions.js